import Script from 'next/script'
import { FC } from 'react'

interface SchemaProduct {
  description: string
  name: string
  previewImg: string
  price: string
  ratingValue: string
  reviewAuthor: string
  reviewPublished: string
  reviewBody: string
  reviewRating: string
}

const SchemaProduct: FC<SchemaProduct> = ({
  description,
  name,
  previewImg,
  price,
  ratingValue,
  reviewAuthor,
  reviewPublished,
  reviewBody,
  reviewRating,
}) => {
  return (
    <Script
      id="schema-org"
      strategy="beforeInteractive"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `
          {
            "@context": "https://schema.org",
            "@type": "Product",
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "${ratingValue}",
              "reviewCount": "20"
            },
            "description": "${description}",
            "name": "${name}",
            "image": "${previewImg}",
            "offers": {
              "@type": "Offer",
              "availability": "https://schema.org/InStock",
              "price": "${price}",
              "priceCurrency": "RUB"
  			    },
  			    "review": {
              "@type": "Review",
              "author": "${reviewAuthor}",
              "datePublished": "${reviewPublished}",
              "reviewBody": "${reviewBody}",
              "name": "${name}",
              "reviewRating": {
                "@type": "Rating",
                "bestRating": "5",
                "ratingValue": "${reviewRating}",
                "worstRating": "1"
			      }
           }
          }
        `,
      }}
    />
  )
}
export default SchemaProduct
